import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { ValidatorFn, AbstractControl } from '@angular/forms';

import { WizardService } from '../wizard/wizard.service';
import { ValidateEmailResponse } from './validate-email-response';
import { Individual } from '../model/individual';
import { LoggerService } from '../logger.service';


@Injectable({
  providedIn: 'root'
})
export class ValidateService {

  constructor(
    private http: HttpClient,
    private logger: LoggerService
  ) { }

  public email(individual: Individual): Observable<ValidateEmailResponse> {
    const oberserable = this.http.get<ValidateEmailResponse>(`/pac-wizard/validate-email/${individual.eml_address}`);
    const shared = oberserable.pipe(share());
    shared.subscribe(result => {
      try {
        this.logger.info(result);
      } catch {}
    });
    return shared;
  }
}
